import { useTranslation } from 'react-i18next';
import classes from './Quality.module.scss';
import image_01 from '../../../assets/img/Home/Quality/image_01.avif';
import image_02 from '../../../assets/img/Home/Quality/image_02.avif';
import { useEffect, useState } from 'react';
import { gsap } from "gsap";
import ScrollTrigger from "gsap/src/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
gsap.config({
    force3D: true,
});


const tabs = [
    {
        subtitle: 'home.quality.tab_01.subtitle',
        desc: 'home.quality.tab_01.desc',
    },
    {
        subtitle: 'home.quality.tab_02.subtitle',
        desc: 'home.quality.tab_02.desc',
    },
    {
        subtitle: 'home.quality.tab_03.subtitle',
        desc: 'home.quality.tab_03.desc',
    },
    {
        subtitle: 'home.quality.tab_04.subtitle',
        desc: 'home.quality.tab_04.desc',
    },
    {
        subtitle: 'home.quality.tab_05.subtitle',
        desc: 'home.quality.tab_05.desc',
    },
];

const Quality = () => {
    const { t } = useTranslation();
    const [active, setActive] = useState(0);

    const setTab = (value) =>
        setActive(value === active ? -1 : value);

    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <div className={[classes.title, 'font-48-24'].join(' ')}>
                    {t('home.quality.title_01')} <br />
                    <span>{t('home.quality.title_02')}</span>
                </div>
                <div className={classes.content}>
                    <div className={classes.col}>
                        <p className={`${classes.text} font-16`}>
                            {t('home.quality.text')}
                        </p>
                        <div className={classes.images}>
                            <div id="qualityWrap_01" className={[classes.imageWrap, classes.imageWrap_01].join(' ')}>
                                <img id="qualityImage_01" src={image_01} alt='' />
                            </div>
                            <div id="qualityImageWrap_02" className={[classes.imageWrap, classes.imageWrap_02].join(' ')}>
                                <img id="qualityImage_02" src={image_02} alt='' />
                            </div>
                        </div>
                    </div>
                    <div className={classes.col}>
                        <div className={classes.tabs}>
                            {tabs.map((tab, index) =>
                                <div
                                    key={index}
                                    onClick={() => setTab(index)}
                                    className={`${classes.acc} ${active === index ? classes.active : ''} no-select`}
                                >
                                    <div className={classes.head}>
                                        <h4 className={`${classes.subtitle} font-20`}>
                                            {t(tab.subtitle)}
                                        </h4>
                                        <div className={classes.status}></div>
                                    </div>
                                    <p className={`${classes.text} font-16`}>
                                        {t(tab.desc)}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={classes.imagesMob}>
                            <img src={image_01} alt='' />
                            <img src={image_02} alt='' />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Quality;
